import TaskDetail from "@/views/task/TaskDetail.vue";
import Tasks from "@/views/task/Tasks.vue";

export default [
    {
        path: "/tasks",
        name: "Tareas",
        component: Tasks,
        meta: {
            requiresAuth: true,
            roles: ['AulaVirtual']
        }
    },
    {
        path: "/task/:id",
        name: "TaskDetail",
        component: TaskDetail,
        meta: {
            requiresAuth: true,
            roles: ['AulaVirtual']
        }
    },
];
